import { useState } from "react";

export function useSessionStorage(key: string): [string, (value: string) => void] {
    // State to store our value
    // Pass initial state function to useState so logic is only executed once
    const [storedValue, setStoredValue] = useState(() => {
        // Get from session storage by key
        const item = window.sessionStorage.getItem(key);
        return item ? item : "";
    });
    // Return a wrapped version of useState's setter function that
    // persists the new value to sessionStorage.
    const setValue = (value: string) => {
        // Save state
        setStoredValue(value);
        // Save to session storage
        window.sessionStorage.setItem(key, value);
    };
    return [storedValue, setValue];
}
